import _ from 'lodash';
import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import './USDatePicker.scss';
import reducerStore from '../../reducers/reducerStore';

class USDatePicker extends React.Component {

    constructor(props) {
        super(props);

        let date;
        if (props.widget.widgetType === 'competition') {
            date = _.get(props.widget.competitionSettings, props.field);
        } else {
            date = _.get(props.widget, props.field);
        }

        this.state = {
            selectedDate: moment(date),
        };
    }

    componentWillReceiveProps(nextProps) {
        let date;
        if (nextProps.widget.widgetType === 'competition') {
            let currentState = reducerStore.getState();
            currentState.slides.find(slide => {
                if (slide.type === 'competition' && slide.id === nextProps.widget.id) {
                    date = slide.competitionSettings[this.props.field];
                }
            });
        } else {
            date = _.get(nextProps.widget, nextProps.field);
        }

        this.setState({
            selectedDate: moment(date),
        });
    }

    setFieldValue(date) {
        this.setState({
            selectedDate: date,
        });

        this.props.setWidgetFieldValue(this.props.field, date.format('YYYY-MM-DD'));
    }

    render() {
        return (
            <DatePicker
                selected={this.state.selectedDate}
                onChange={(date) => this.setFieldValue(date)}
                dateFormat="YYYY-MM-DD"
                locale="sv"
                className="form-control"
                placeholderText={this.props.placeholderText}
                minDate={this.props.minDate}
                maxDate={this.props.maxDate}
            />
        );
    }
}

USDatePicker.propTypes = {
    widget: React.PropTypes.object,
    setWidgetFieldValue: React.PropTypes.func.isRequired,
    field: React.PropTypes.string.isRequired,
    placeholderText: React.PropTypes.string,
    minDate: React.PropTypes.object,
    maxDate: React.PropTypes.object,
};

export default USDatePicker;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/USDatePicker.jsx
 **/